import { notification } from "antd"
import { useEffect } from "react"
import { useTranslation } from "react-i18next"

import PersonBriefDrawer from "~/containers/person-brief/person-brief-drawer"
import {
  isPmbV1,
  openPmbV2Workbench,
  PMB_V2_MISSING_LINKEDIN_MESSAGE
} from "~/containers/pre-meeting-brief-v2"

type DialerPerson = {
  id?: string | number
  name?: string
  title?: string
  linkedin_url?: string
  account?: { id?: string | number; name?: string }
}

export default function PersonBriefHost({
  person,
  onClose
}: {
  person: DialerPerson | null
  onClose: () => void
}) {
  const { t } = useTranslation()
  const linkedinUrl = person?.linkedin_url?.trim() ?? ""
  const accountId = person?.account?.id
  const accountName = person?.account?.name ?? ""

  useEffect(() => {
    if (!person) return
    if (!linkedinUrl) {
      notification.error({
        message: t("label_error"),
        description: PMB_V2_MISSING_LINKEDIN_MESSAGE
      })
      onClose()
      return
    }
    if (!isPmbV1) {
      openPmbV2Workbench({
        linkedinUrl,
        accountId:
          accountId != null && /^\d+$/.test(String(accountId))
            ? Number(accountId)
            : null,
        apolloId: null,
        opportunityId: null,
        personName: person.name,
        accountName,
        source: "voice_dialer"
      })
      onClose()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [person?.id, linkedinUrl])

  if (!person || !linkedinUrl || !isPmbV1) return null

  return (
    <PersonBriefDrawer
      account_name={accountName}
      linkedin_url={linkedinUrl}
      personName={person.name ?? ""}
      accountDbId={accountId ?? null}
      isOpen={!!person}
      setIsOpen={(open) => {
        if (!open) onClose()
      }}
    />
  )
}
